export { HistoryEntrypoint } from './scope';
export type { HistoryAddOptions } from './types';
export { hooks } from './hooks';
